import { render } from "./Header.vue?vue&type=template&id=b8ddffbe&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=b8ddffbe&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/MoTobi-Web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8ddffbe"]])

export default __exports__